"use client";

import { CalendarClock } from "lucide-react";
import DashboardCard from "./DashboardCard";
import { useExamDday } from "@/hooks/useExamDday";

/** D-day 숫자 → 표시 라벨. */
function ddayLabel(d: number | null): string {
  if (d === null) return "—";
  if (d < 0) return "종료";
  if (d === 0) return "D-DAY";
  return `D-${d}`;
}

/**
 * 대시보드 "시험 D-day" 위젯 (JCG-2073).
 * 시험일/계산 로직은 홈의 DdayDisplay와 동일한 활성 회차 데이터를 공유한다.
 */
export default function DashboardDday({
  className,
}: {
  className?: string;
}) {
  const { data, isPending } = useExamDday();

  return (
    <DashboardCard
      icon={CalendarClock}
      title="시험 D-day"
      href="/exam-registration/jcg-test-center"
      linkLabel="시험 정보"
      className={className}
    >
      <span className="block text-3xl font-extrabold text-red-500 tabular-nums dark:text-red-400">
        {ddayLabel(data?.dday ?? null)}
      </span>
      <p className="mt-1.5 text-[11px] text-muted-foreground">
        {data?.label ?? (isPending ? "시험 일정 확인 중" : "시험 일정을 확인해주세요")}
      </p>
    </DashboardCard>
  );
}
